<template>
	<div class="flex justify-center gap-1">
		<div
			class="bg-fill-secondary text-label-secondary inline-flex h-6.5 items-center rounded-full px-2 text-xs font-medium uppercase"
		>
			<slot>{{ t('itemsSelected', count) }}</slot>
		</div>
		<div
			class="bg-fill-secondary inline-flex h-6.5 items-center rounded-full pr-2 pl-1"
		>
			<CoinPrice class="*:text-label-secondary!" size="xs" :price="total" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CoinPrice from './CoinPrice.vue'

const { t } = useI18n({
	messages: {
		en: {
			itemsSelected: '0 gifts selected | 1 gift selected | {n} gifts selected'
		},
		ru: {
			itemsSelected:
				'0 гифтов выбрано | {n} гифт выбран | {n} гифта выбрано | {n} гифтов выбрано'
		}
	}
})

defineProps<{
	count: number
	total: number
}>()
</script>
